import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiUrl } from './api.url';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private http: HttpClient) { }

  /**
   * Get available user roles for companies
   * GET /utility/roles
   */
  getRoles(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.webappBaseUrl}${ApiUrl.GET_UTILITY_ROLES}`);
  }
}
